import { IonNavCustomEvent } from "@ionic/core";
import { IonButton, IonButtons, IonContent, IonNav, IonToolbar } from "@ionic/react";
import { useContext, useState } from "react";

import { DynamicDismissableModalContext } from "#/features/shared/DynamicDismissableModal";

import Join from "./join/Join";
import LoggedOut from "#/features/user/LoggedOut";
import { useLocation } from "react-router";
import AppHeader from "#/features/shared/AppHeader";

function blurDocument() {
  (document.activeElement as HTMLElement)?.blur();
}

export default function LoginNav() {
  const { dismiss } = useContext(DynamicDismissableModalContext);
  const location = useLocation();
  const [root] = useState(
    () =>
      function render() {
        return (
          <IonContent>
            {location.pathname?.includes('profile')
              ? <Join showCloseBtn={true} />
              : <>
                  <AppHeader>
                    <IonToolbar>
                      <IonButtons slot="start">
                        <IonButton strong onClick={() => dismiss()}>
                          Close
                        </IonButton>
                      </IonButtons>
                    </IonToolbar>
                  </AppHeader>
                  <LoggedOut />
                </>
            }
          </IonContent>
        );
      },
  );

  const { setCanDismiss } = useContext(DynamicDismissableModalContext);

  async function onIonNavDidChange(event: IonNavCustomEvent<void>) {
    if ((await event.target.getLength()) === 1) {
      setCanDismiss(true);
    }
  }

  return (
    <IonNav
      root={root}
      onIonNavWillChange={blurDocument}
      onIonNavDidChange={onIonNavDidChange}
    />
  );
}
